import axios from "axios";

/* ================= AXIOS INSTANCE ================= */
const apiService = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
});

/* ================= ATTACH JWT TOKEN ================= */
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= EXISTING API HELPERS ================= */
const API_URL = "/apis";

export const getApis = (apiType) => {
  return apiService.get(
    `${API_URL}?api_type=${apiType}`
  );
};

export const createApi = (data) => {
  return apiService.post(API_URL, data);
};

export const updateApi = (id, data) => {
  return apiService.put(`${API_URL}/${id}`, data);
};

export const deleteApi = (id) => {
  return apiService.delete(`${API_URL}/${id}`);
};

/* ================= DEFAULT EXPORT ================= */
export default apiService;
